import React, { act, useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import google from "../../assests/Icons/google.svg";
import apple from "../../assests/Icons/apple.svg";
import discordImage from "../../assests/Icons/discord.svg";
import RscLogo from "../../assests/logo/rscLogo";
import shield from "../../assests/Icons/shield.svg";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useLocation, useNavigate } from "react-router-dom";
import AddressAutocomplete from "../../components/AddressAutocompleteComponent/GoogleAddressInput";
import stateandcities from "../../assests/stateAndCities/stateandcities";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useDispatch } from "react-redux";
import {
  forgottonPassword,
  getDiscordId,
  registerUser,
  verifyEmailByOtp,
} from "../../reducers/authentication.slice";
import "react-toastify/dist/ReactToastify.css";
import CustomLoader from "../../components/CustomLoader";
import { use } from "react";
import { AuthContext } from "../../context/authContext";

const SignUpPageWrapper = styled(Stack)(({ theme }) => ({
  minHeight: "100vh", // This ensures it takes at least full viewport height
  height: "100%", // This can make sure the element fills the screen
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#000000",
  overflow: "auto", // Ensure content doesn't overflow outside the viewport
}));

const SignUpPageComponent = styled(Stack)(({ theme }) => ({
  padding: "24px",
  backgroundColor: "#101010",
  borderRadius: "10px",
  border: "1px solid #ffffff85",
  width: "370px",
  [theme.breakpoints.down("md")]: {
    width: "480px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "320px",
    padding: "16px",
  },
  [theme.breakpoints.down("xs")]: {
    width: "95%",
    padding: "16px",
  },
}));

const LogoSectionWrapper = styled(Stack)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
}));

const LogoDisplaySection = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: "white",
  width: "fit-content",
  borderRadius: "3px",
}));

const CustomFormLabel = styled(FormLabel)(({ theme }) => ({
  color: "white",
  marginBottom: "8px",
  fontFamily: "Inter",
  letterSpacing: "0.8px",
  marginTop: "10px",
}));

// const Button = styled(Button)(({ theme }) => ({
//   textTransform: "none",
//   color: "#000000",
//   backgroundColor: "white",
//   marginTop: "16px",
//   fontWeight: 500,
//   fontSize: "1.1rem",
//   "&.Mui-disabled": {
//     color: "white",
//     backgroundColor: "#565656",
//     opacity: 1,
//   },
// }));

const DividerSection = styled(Stack)(({ theme }) => ({
  marginTop: "35px",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
}));

const Line = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff85",
  height: "1px", // Thin line
  width: "100%",
  zIndex: 1, // Make sure the line is behind the "or" text
}));

const OrBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#000000",
  borderRadius: "20px",
  padding: "5px 15px",
  zIndex: 2,
  position: "absolute",
  color: "white",
}));

const SignUpSection = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  marginTop: "30px",
}));

const SignUpComponent = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  padding: theme.spacing(1.5),
  alignItems: "center",
  border: "1px solid #ffffff85",
  borderRadius: "10px",
  cursor: "pointer",
}));

const LogoSection = styled(Stack)(({ theme, image }) => ({
  width: "10%",
  height: "20px",
  padding: "5px",
  backgroundImage: `url(${image})`,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
}));

const SignUpContentSection = styled(Stack)(({ theme, image }) => ({
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
}));

const SignUpAction = styled(Stack)(({ theme, image }) => ({
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
}));

const ValidationSection = styled(Stack)(({ theme, image }) => ({
  gap: 2,
  flexDirection: "row",
}));

const SignupPage = () => {
  const location = useLocation();

  const [discord, setDiscord] = useState("");
  const [discordIds, setDiscordIds] = useState(() => {
    const savedDiscordIds = sessionStorage.getItem("discordIds");
    return savedDiscordIds ? JSON.parse(savedDiscordIds) : [];
  });
  const [error, setError] = useState(false);
  const [activeStep, setActiveStep] = useState(
    JSON.parse(sessionStorage.getItem("activeStep")) || 0
  );
  const [showLoader, setShowLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [discordCheck, setDiscordCheck] = useState(false);
  const [formData, setFormData] = useState(() => {
    const savedFormData = sessionStorage.getItem("formData");
    return savedFormData
      ? JSON.parse(savedFormData)
      : {
          first_name: "",
          last_name: "",
          address_details: {
            address: "",
            building: "",
            city: "",
            state: "",
            zipcode: "",
          },
          email: "" || location?.state?.email,
          password: "",
          confirmPassword: "",
          otp: "",
        };
  });
  const navigate = useNavigate();
  const [isLengthValid, setIsLengthValid] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);
  const dispatch = useDispatch();
  const [emailVid, setEmailVid] = useState("");
  const [discordRole, setDiscordRole] = useState("");
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    sessionStorage.setItem("formData", JSON.stringify(formData));
  }, [formData]);

  useEffect(() => {
    let interval = null;

    if (activeStep === 4 && timer > 0 && !canResend) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            setCanResend(true);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [timer, activeStep, canResend]);

  const isVerifiedCheck = location?.state?.isVerifiedCheck;

  const { showToast } = useContext(AuthContext);

  const handleNewPasswordChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    const lengthValid = value?.length >= 8 && value?.length <= 125;
    setIsLengthValid(lengthValid);

    const numberValid = /\d/.test(value);
    setHasNumber(numberValid);

    const upperCaseValid = /[A-Z]/.test(value);
    setHasUpperCase(upperCaseValid);

    const specialCharValid = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    setHasSpecialChar(specialCharValid);
  };

  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleInputChange = (e) => {
    setDiscord(e.target.value);
  };

  const handleFormData = (event) => {
    const { name, value } = event.target;
    let errorMsg = "";

    if (
      ["first_name", "last_name"].includes(name) &&
      !/^[a-zA-Z\s]*$/.test(value)
    ) {
      errorMsg = `${name === "first_name" ? "First" : "Last"} name can only contain letters and spaces.`;
    }

    if (name === "email") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(value)) {
        errorMsg = "Please enter a valid email address.";
      }
    }

    setErrors((prev) => ({
      ...prev,
      [name]: errorMsg,
    }));

    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const resendOtp = () => {
    setShowLoader(true);
    const payload = {
      email: formData.email,
      email_type: "RESEND_OTP",
    };
    dispatch(forgottonPassword(payload)).then((res) => {
      if (res?.error && Object.keys(res?.error)?.length > 0) {
        showToast(res?.error?.message, "error");
        setShowLoader(false);
        return;
      }
      if (res?.payload?.id) {
        setTimer(60);
        setCanResend(false);
        setShowLoader(false);
        setDiscordCheck(false);
        setEmailVid(res?.payload?.id);
        if (activeStep === 3) {
          setActiveStep(activeStep + 1);
        }
      }
    });
  };

  const handleCheckEmail = (e) => {
    e.preventDefault();
    if (!emailRegex.test(formData.email)) {
      setError(true);
    } else {
      setShowLoader(true);
      if (isVerifiedCheck) {
        resendOtp();
      } else {
        const payload = {
          ...formData,
        };
        delete payload.confirmPassword;
        delete payload.otp;

        if (discordCheck) {
          payload.discord_id = discord;
          payload.discord_role_ids = discordIds;
        }

        dispatch(registerUser(payload)).then((res) => {
          if (res?.error && Object.keys(res?.error)?.length > 0) {
            showToast(res?.error?.message, "error");
            setShowLoader(false);
            return;
          }
          if (res?.payload?.id) {
            setShowLoader(false);
            setDiscordCheck(false);
            setEmailVid(res?.payload?.id);
            setActiveStep(activeStep + 1);
          }
        });
      }
    }
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    if (formData.otp?.length === 6) {
      const payload = {
        otp: formData.otp,
        id: emailVid,
      };
      setShowLoader(true);
      dispatch(verifyEmailByOtp(payload)).then((res) => {
        if (res?.error && Object.keys(res?.error)?.length > 0) {
          showToast(res?.error?.message, "error");
          setShowLoader(false);
          return;
        }
        localStorage.setItem("user", JSON.stringify(res?.payload));
        if (res?.payload?.is_verified) {
          setShowLoader(false);
          sessionStorage.removeItem("formData");
          sessionStorage.removeItem("discordIds");
          sessionStorage.removeItem("activeStep");
          if (res?.payload?.role === "MEMBER") {
            navigate("/user-dashboard");
          } else if (res?.payload?.role === "MANAGER") {
            navigate("/manager-dashboard");
          } else if (res?.payload?.role === "SUPERADMIN") {
            navigate("/admin-dashboard");
          } else if (res?.payload?.role === "WAREHOUSE_ADMIN" || res?.payload?.role === "WAREHOUSE_STAFF") {
            navigate("/warehouse/inbound");
          } else {
            showToast("Invalid User", "error");
          }
        }
      });
    }
  };

  const handleFormInputChange = (e) => {
    const { value, name } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleAddressAutocompleteChange = (value) => {
    setFormData({
      ...formData,
      address_details: {
        ...formData.address_details,
        address: value?.street,
        city: value?.city,
        state: value?.state,
        zipcode: value?.zip,
      },
    });
  };

  const handleAddressChange = (name, value) => {
    setFormData({
      ...formData,
      address_details: {
        ...formData.address_details,
        [name]: value,
      },
    });
  };

  useEffect(() => {
    sessionStorage.setItem("activeStep", activeStep);
  }, [activeStep]);

  const handleLoginGoogle = () => {};
  const handleLoginApple = () => {};
  const handleLoginDiscord = () => {};

  const signUpUser = async (payload) => {
    // setSaving(true);
    // try {
    //   if (discordRole) {
    //     payload.discordRole = discordRole;
    //   }
    //   if (discordId) {
    //     payload.discordId = discordId;
    //   }
    //   if (appleId) {
    //     payload.appleId = appleId;
    //   }
    //   if (googleId) {
    //     payload.googleId = googleId;
    //   }
    //   const res = await $axios.post(`${$baseUrl}/auth/register`, payload);
    //   if (res) {
    //     toast.success("Registered Successfully!");
    //     setScreen(5);
    //     setSaving(false);
    //   }
    // } catch (error) {
    //   console.log(error);
    //   setSaving(false);
    //   toast.error(error.response?.message || error.response?.data?.message);
    // }
  };

  const signupaction = [
    {
      title: "Continue with Google",
      logo: google,
      action: handleLoginGoogle,
    },
    {
      title: "Continue with Apple",
      logo: apple,
      action: handleLoginApple,
    },
    {
      title: "Continue with Discord",
      logo: discordImage,
      action: handleLoginDiscord,
    },
  ];

  const states = stateandcities;

  const disableSecondPageButton =
    formData?.address_details.address === "" ||
    formData?.address_details.city === "" ||
    formData?.address_details.state === "" ||
    formData?.address_details.zipcode === "";
  // const disableThirdPageButton = formData.email == "" || errors.email;
  // const disableFourthPageButton =
  //   formData.password == "" ||
  //   formData.confirmPassword == "" ||
  //   !isLengthValid ||
  //   !hasNumber ||
  //   !hasUppercase ||
  //   !passwordsMatch;
  // const disableFifthPageButton = formData.otp == "" || errors.otp;

  const handleLinkDiscord = (e) => {
    e.preventDefault();
    const payload = {
      discord_id: discord,
    };
    setShowLoader(true);
    dispatch(getDiscordId(payload)).then((res) => {
      if (res?.error && Object.keys(res?.error)?.length > 0) {
        showToast(res?.error?.message, "error");
        setShowLoader(false);
        return;
      }
      setShowLoader(false);
      const discordRole =
        res?.payload?.discord_role_names?.length > 0
          ? res?.payload?.discord_role_names[0]
          : "No Role";
      setDiscordRole(discordRole);
      setDiscordIds(res?.payload?.discord_role_ids);
      sessionStorage.setItem(
        "discordIds",
        JSON.stringify(res?.payload?.discord_role_ids)
      );
      setDiscordCheck(true);
      setActiveStep(1);
    });
  };

  const discordRoleBasedColor = discordRole?.replace(" ", "").toUpperCase();

  const clearFormData = () => {
    sessionStorage.removeItem("formData");
    setFormData({
      first_name: "",
      last_name: "",
      address_details: {
        address: "",
        building: "",
        city: "",
        state: "",
        zipcode: "",
      },
      email: "",
      password: "",
      confirmPassword: "",
      otp: "",
    });
  };

  return (
    <>
      <CustomLoader open={showLoader} />
      <SignUpPageWrapper>
        <SignUpPageComponent>
          <LogoSectionWrapper sx={{ mb: 4 }}>
            <LogoDisplaySection>
              <RscLogo color="black" />
            </LogoDisplaySection>
            {((activeStep !== 0 && !isVerifiedCheck) ||
              (isVerifiedCheck && activeStep > 5)) && (
              <Stack
                gap={1}
                flexDirection={"row"}
                alignContent={"center"}
                color={"#ffffff85"}
                sx={{ cursor: "pointer" }}
                onClick={() =>
                  setActiveStep(
                    activeStep === 2 ? activeStep - 2 : activeStep - 1
                  )
                }
              >
                <KeyboardBackspaceIcon />
                <Typography fontFamily={"inter"}>Back</Typography>
              </Stack>
            )}
          </LogoSectionWrapper>
          {activeStep === 0 ? (
            <>
              {" "}
              <Typography
                sx={{
                  fontSize: "1.7rem",
                  color: "white",
                  fontWeight: 700,
                }}
              >
                Let’s get started!{" "}
              </Typography>
              <Typography
                sx={{
                  color: "#ffffff85",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: "0.8rem",
                }}
              >
                We’ll need a few details to set up your account. First, let’s
                start with your name.
              </Typography>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  setActiveStep(activeStep + 1);
                }}
              >
                <FormControl fullWidth>
                  <CustomFormLabel htmlFor="first_name">
                    First Name
                  </CustomFormLabel>
                  <TextField
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    placeholder="First Name"
                    onChange={handleFormData}
                    error={!!errors.first_name}
                    helperText={errors.first_name || ""}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <CustomFormLabel htmlFor="last_name">
                    Last Name
                  </CustomFormLabel>
                  <TextField
                    type="text"
                    name="last_name"
                    value={formData.last_name}
                    placeholder="Last Name"
                    onChange={handleFormData}
                    error={!!errors.last_name}
                    helperText={errors.last_name || ""}
                  />
                </FormControl>
                <Button
                  disabled={
                    !formData.first_name ||
                    !formData.last_name ||
                    !!errors.first_name ||
                    !!errors.last_name
                  }
                  variant="contained"
                  type="submit"
                  fullWidth
                >
                  Next
                </Button>
              </form>
            </>
          ) : activeStep === 1 ? (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setActiveStep(activeStep + 1);
              }}
            >
              <Stack spacing={1}>
                <Typography
                  sx={{
                    fontSize: "1.7rem",
                    color: "white",
                    fontWeight: 700,
                  }}
                >
                  Shipping Address
                </Typography>
                <Typography
                  sx={{
                    color: "#ffffff85",
                    fontFamily: "Inter",
                    fontWeight: 300,
                    fontSize: "0.8rem",
                  }}
                >
                  Please provide your shipping address for deliveries and order
                  tracking.
                </Typography>
                {/* Address */}
                <FormControl fullWidth required>
                  <CustomFormLabel htmlFor="address">Address</CustomFormLabel>
                  <AddressAutocomplete
                    onChange={(value) => {
                      handleAddressAutocompleteChange(value);
                    }}
                    defaultValue={formData?.address_details}
                  />
                </FormControl>

                {/* Apartment/Suite */}
                <FormControl fullWidth>
                  <CustomFormLabel htmlFor="building">
                    Apartment/Suite (Optional)
                  </CustomFormLabel>
                  <TextField
                    type="text"
                    name="building"
                    value={formData?.address_details?.building}
                    placeholder="Apartment/Suite"
                    onChange={(e) =>
                      handleAddressChange("building", e.target.value)
                    }
                  />
                </FormControl>

                {/* State */}
                <FormControl fullWidth required>
                  <CustomFormLabel htmlFor="state">State</CustomFormLabel>
                  <Select
                    value={formData?.address_details?.state}
                    onChange={(e) =>
                      handleAddressChange("state", e.target.value)
                    }
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <Typography
                            style={{ color: "rgba(255, 255, 255, 0.5)" }}
                          >
                            Select State
                          </Typography>
                        );
                      }
                      return selected;
                    }}
                    sx={{
                      borderRadius: "4px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "4px",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "4px",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "4px",
                      },
                    }}
                  >
                    {states.map((state, index) => (
                      <MenuItem key={index} value={state.value}>
                        {state.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* City */}
                <FormControl fullWidth required>
                  <CustomFormLabel htmlFor="city">City</CustomFormLabel>
                  <TextField
                    type="text"
                    name="city"
                    value={formData?.address_details?.city}
                    placeholder="City"
                    onChange={(e) =>
                      handleAddressChange("city", e.target.value)
                    }
                  />
                </FormControl>

                {/* Zip Code */}
                <FormControl fullWidth required sx={{ marginBottom: 2 }}>
                  <CustomFormLabel htmlFor="zipcode">Zip Code</CustomFormLabel>
                  <TextField
                    type="text"
                    name="zipcode"
                    value={formData?.address_details?.zipcode}
                    placeholder="Zip Code"
                    onChange={(e) =>
                      handleAddressChange("zipcode", e.target.value)
                    }
                  />
                </FormControl>

                {/* Submit Button */}
                <Button
                  fullWidth
                  variant="contained"
                  type="submiy"
                  // disabled={disableSecondPageButton || errorsCount !== 0 || saving}
                  disabled={disableSecondPageButton}
                >
                  {/* {appleId || googleId || discordId || formData.email !== ""
                ? "Register"
                : "Next"} */}
                  Next
                </Button>
              </Stack>
            </form>
          ) : activeStep === 2 ? (
            <>
              <Typography
                sx={{
                  fontSize: "1.7rem",
                  color: "white",
                  fontWeight: 700,
                }}
              >
                Secure your account{" "}
              </Typography>
              <Typography
                sx={{
                  color: "#ffffff85",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: "0.8rem",
                }}
              >
                Set a strong password to protect your account.
              </Typography>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  setActiveStep(activeStep + 1);
                }}
              >
                <FormControl fullWidth sx={{ marginTop: 2 }}>
                  <CustomFormLabel htmlFor="last_name">
                    New Password
                  </CustomFormLabel>
                  <TextField
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    sx={{ marginBottom: 1 }}
                    placeholder="Password"
                    onChange={handleNewPasswordChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ marginRight: 3 }}>
                          <IconButton
                            aria-label={
                              showPassword
                                ? "hide the password"
                                : "show the password"
                            }
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {showPassword ? (
                              <Visibility sx={{ color: "#ffffff85" }} />
                            ) : (
                              <VisibilityOff sx={{ color: "#ffffff85" }} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
                <Stack sx={{ gap: 2, marginTop: 3 }}>
                  <ValidationSection>
                    <CheckCircleIcon
                      sx={{ color: !isLengthValid ? "#ffffff85" : "#4CAF50" }}
                    />{" "}
                    <Typography sx={{ color: "#ffffff85", ml: 1 }}>
                      {" "}
                      8 to 125 Characters
                    </Typography>
                  </ValidationSection>
                  <ValidationSection>
                    <CheckCircleIcon
                      sx={{ color: !hasNumber ? "#ffffff85" : "#4CAF50" }}
                    />{" "}
                    <Typography sx={{ color: "#ffffff85", ml: 1 }}>
                      {" "}
                      At least 1 number{" "}
                    </Typography>
                  </ValidationSection>
                  <ValidationSection>
                    <CheckCircleIcon
                      sx={{ color: !hasUpperCase ? "#ffffff85" : "#4CAF50" }}
                    />{" "}
                    <Typography sx={{ color: "#ffffff85", ml: 1 }}>
                      {" "}
                      At least 1 uppercase letter{" "}
                    </Typography>
                  </ValidationSection>
                  <ValidationSection>
                    <CheckCircleIcon
                      sx={{ color: !hasSpecialChar ? "#ffffff85" : "#4CAF50" }}
                    />{" "}
                    <Typography sx={{ color: "#ffffff85", ml: 1 }}>
                      {" "}
                      At least 1 Special Charchter{" "}
                    </Typography>
                  </ValidationSection>
                </Stack>
                <FormControl fullWidth sx={{ marginTop: 2 }}>
                  <CustomFormLabel htmlFor="last_name">
                    Confirm Password
                  </CustomFormLabel>
                  <TextField
                    type={showPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    sx={{ marginBottom: 1 }}
                    placeholder="Confirm Password"
                    onChange={handleFormData}
                    error={
                      formData.confirmPassword.length > 0 &&
                      formData.password !== formData.confirmPassword
                    }
                    helperText={
                      formData.confirmPassword.length > 0 &&
                      formData.password !== formData.confirmPassword
                        ? "Password do not match "
                        : ""
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ marginRight: 3 }}>
                          <IconButton
                            aria-label={
                              showPassword ? "hide password" : "show password"
                            }
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {showPassword ? (
                              <Visibility sx={{ color: "#ffffff85" }} />
                            ) : (
                              <VisibilityOff sx={{ color: "#ffffff85" }} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
                <Button
                  disabled={
                    !isLengthValid ||
                    !hasNumber ||
                    !hasUpperCase ||
                    !hasSpecialChar ||
                    formData.password !== formData.confirmPassword
                  }
                  variant="contained"
                  fullWidth
                  type="submit"
                >
                  Confirm
                </Button>
              </form>
            </>
          ) : activeStep === 3 ? (
            <>
              {" "}
              <Typography
                sx={{
                  fontSize: "1.7rem",
                  color: "white",
                  fontWeight: 700,
                }}
              >
                Verify Your Email
              </Typography>
              <Typography
                sx={{
                  color: "#ffffff85",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: "0.8rem",
                }}
              >
                To secure your account, please enter your email address. We'll
                send a 6-digit code to verify it.
              </Typography>
              <form onSubmit={handleCheckEmail}>
                <FormControl fullWidth>
                  <CustomFormLabel htmlFor="Email">Email</CustomFormLabel>
                  <TextField
                    type="email"
                    name="email"
                    value={formData.email}
                    placeholder="Email"
                    onChange={handleFormData}
                    error={!!errors.email}
                    helperText={errors.email}
                  />
                  <Button
                    disabled={formData.email?.length === 0 || !!errors.email}
                    variant="contained"
                    type="submit"
                  >
                    Send Verification Code
                  </Button>
                </FormControl>
              </form>
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontSize: "1.7rem",
                  color: "white",
                  fontWeight: 700,
                }}
              >
                Verify Your Identity{" "}
              </Typography>
              <Typography
                sx={{
                  color: "#ffffff85",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: "0.8rem",
                }}
              >
                We’ve sent a verification code to your email. Please enter the
                code below to proceed with resetting your password.
              </Typography>
              <form onSubmit={handleVerifyOtp}>
                <FormControl fullWidth>
                  <CustomFormLabel htmlFor="Email">
                    Verification Code
                  </CustomFormLabel>
                  <TextField
                    type="text"
                    name="otp"
                    value={formData.otp}
                    placeholder="Verification Code"
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d{0,6}$/.test(input)) {
                        handleFormData(e);
                      }
                    }}
                    inputProps={{
                      maxLength: 6,
                      pattern: "[0-9]*",
                    }}
                    helperText={
                      formData.otp && formData.otp?.length !== 6
                        ? "Verification Code must be a 6-digit number"
                        : ""
                    }
                  />

                  <Button
                    disabled={formData.otp?.length < 6}
                    variant="contained"
                    type="submit"
                  >
                    Submit
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{ marginTop: 2 }}
                    textAlign={"center"}
                  >
                    {canResend ? (
                      <Stack
                        gap={1}
                        flexDirection={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <Typography
                          onClick={canResend ? resendOtp : null}
                          variant="body2"
                          textAlign={"center"}
                          fontWeight={"bold"}
                          sx={{
                            cursor: canResend ? "pointer" : "default",
                            textTransform: "none",
                          }}
                        >
                          Didn't receive Verification Code? Resend code
                        </Typography>
                      </Stack>
                    ) : (
                      `Didn't receive Verification Code? Resend in ${timer}s`
                    )}
                  </Typography>
                </FormControl>
              </form>
            </>
          )}
          {activeStep === 0 && (
            <>
              {" "}
              <DividerSection>
                <Line />
                <OrBox>or</OrBox>
              </DividerSection>
              <SignUpSection>
                <SignUpAction>
                  <Typography
                    sx={{
                      color: "#ffffff85",
                      fontFamily: "Inter",
                      fontWeight: 300,
                      fontSize: "0.8rem",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/login")}
                  >
                    Have an account? Log In{" "}
                  </Typography>
                </SignUpAction>
              </SignUpSection>
            </>
          )}
        </SignUpPageComponent>
      </SignUpPageWrapper>
    </>
  );
};

export default SignupPage;
